import { initAppointment } from '../../templates/components/schedule-appointment/schedule-appointment';

let tourYourWayArray;
let askAQuestionArray;
let floorPlanMatchArray;
let moveInSpecialArray;

export const handQueryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const perqQueryParam = searchParams.get('prop_exp');
  if (PERQHub && perqQueryParam) {
    const typeKeysMap = new Map(
      Object.keys(PERQHub.experience.type).map((key) => [key.toLowerCase(), key])
    );
    if (typeKeysMap.has(perqQueryParam.toLowerCase())) {
      PERQHub.experience.launch(PERQHub.experience.type[typeKeysMap.get(perqQueryParam.toLowerCase())]);
    }
  }
}

export const initPerqButtonsHandler = (el) => {
  console.log('initPerqButtonsHandler');
  if (el) {
    tourYourWayArray = el.querySelectorAll('#tour-your-way');
    askAQuestionArray = el.querySelectorAll('#ask-a-question');
    tourYourWayArray.forEach((btn) => {
      btn.addEventListener('click', initAppointment);
    });
  }
}

export const initPerqOptionalHandler = (el) => {
  if (el) {
    floorPlanMatchArray = el.querySelectorAll('.floor-plan-match');
    moveInSpecialArray = el.querySelectorAll('.move-in-special');
  }
  console.log(el, floorPlanMatchArray, moveInSpecialArray);
}

const isPERQAvailable = () => {
  return typeof PERQHub !== 'undefined';
}

const tourYourWayClickHandler = () => {
  if (isPERQAvailable()) {
    PERQHub.experience.launch(PERQHub.experience.type.Tour);
  } else {
    initAppointment();
  }
}

const askAQuestionClickHandler = () => {
  if (isPERQAvailable()) {
    PERQHub.experience.launch(PERQHub.experience.type.Chat);
  }
}

const floorPlanMatchClickHandler = (e) => {
  e.preventDefault();
  if (isPERQAvailable()) {
    PERQHub.experience.launch(PERQHub.experience.type.PerfectFloorPlan);
  }
}

const moveInSpecialClickHandler = (e) => {
  e.preventDefault();
  if (isPERQAvailable()) {
    PERQHub.experience.launch(PERQHub.experience.type.Offers);
  }
}

window.addEventListener('PERQHubReady', function () {
  if (tourYourWayArray && tourYourWayArray.length > 0) {
    tourYourWayArray.forEach((btn) => {
      btn.removeEventListener('click', initAppointment);
      btn.addEventListener('click', tourYourWayClickHandler);
      btn.disabled = false;
      if (btn.classList.contains('dynamic')) {
        const inPageNav = document.querySelector('.inpage-nav');
        if (inPageNav) {
          const tourYourWayDynamic = inPageNav.querySelector('#tour-your-way');
          if (tourYourWayDynamic) {
            tourYourWayDynamic.disabled = false;
          }
        }
      }
    });
  }

  if (askAQuestionArray && askAQuestionArray.length > 0) {
    askAQuestionArray.forEach((btn) => {
      btn.addEventListener('click', askAQuestionClickHandler);
      btn.disabled = false;
      if (btn.classList.contains('dynamic')) {
        const inPageNav = document.querySelector('.inpage-nav');
        if (inPageNav) {
          const askAQuestionDynamic = inPageNav.querySelector('#ask-a-question');
          if (askAQuestionDynamic) {
            askAQuestionDynamic.disabled = false;
          }
        }
      }
    });
  }

  floorPlanMatchArray = document.querySelectorAll('.floor-plan-match');
  moveInSpecialArray = document.querySelectorAll('.move-in-special-link');

  if (floorPlanMatchArray && floorPlanMatchArray.length > 0) {
    floorPlanMatchArray.forEach((btn) => {
      btn.addEventListener('click', floorPlanMatchClickHandler);
      btn.style.display = "flex";
    })
  }

  if (moveInSpecialArray && moveInSpecialArray.length > 0) {
    moveInSpecialArray.forEach((btn) => {
      btn.addEventListener('click', moveInSpecialClickHandler);
      btn.style.display = "flex";
    })
  }

  handQueryParams();
});



// WEBPACK FOOTER //
// ./src/js/components/perq-controller.js